<template>
  <main id="profilePurchaseHistoryPage" class="container mb-3">
    <div class="row">
      <CustomerProfileNavComponent id="sideNav"
                                   class="col-lg-4 col-sm-12 side-nav"
      ></CustomerProfileNavComponent>
      <div class="col-lg-8 col col-sm-12 profile-page">
        <div class="purchase-history__main-wrapper ">
          <div class="purchase-history__header-wrapper">
            <h3 class="purchase-history__header">{{ $t('profile_order_history_page_title') }}</h3>
          </div>

          <template v-for="booking in bookings">
            <template v-if="booking.service_type === ServiceTypes.SERVICE_RENT">
              <div class="purchase-history__ticket-wrapper col-12">
                <div class="purchase-history__ticket">
                  <div>
                    <!--    Booking history record top    -->
                    <div class="purchase-history__ticket__top">
                      <span class="purchase-history__ticket__top__id" dir="ltr">{{ 'Nr. ' + booking.id }} - {{ $t('vehicle_rent') }} ({{ booking.created_at.split('T')[0] }})</span>
                      <div class="purchase-history__ticket__top__actions-wrapper">
                        <span class="purchase-history__ticket__top__actions"
                              @click="handlePayTheBooking(booking)"
                              v-if="!booking.payment && isBookingPickupDateLaterThanToday(booking)"
                        >
                          {{ $t('pay_order') }}
                        </span>
                        <span class="purchase-history__ticket__top__actions"
                              @click="handleDownloadInvoiceAndPreInvoice(booking.pre_invoice_url!, booking.pre_invoice_file_name!)"
                              v-if="booking.receipt"
                        >
                          {{ $t('pre_invoice')}}
                        </span>
                        <span class="purchase-history__ticket__top__actions"
                              @click="handleDownloadInvoiceAndPreInvoice(booking.invoice_url!, booking.invoice_file_name!)"
                              v-if="booking.payment"
                        >
                          {{$t('invoice')}}
                        </span>
                      </div>
                    </div>

                    <!--    Booking history record mid    -->
                    <div class="purchase-history__ticket__mid">
                      <div class="purchase-history__ticket__mid-inner">
                        <span class=" purchase-history__ticket__mid-inner__title">
                          {{ booking.vehicle.make + ' ' + booking.vehicle.model + ' ' + $t('rent') }}
                        </span>
                        <span class=" purchase-history__ticket__mid-inner__date">{{ booking.journey_date }}</span>
                      </div>
                    </div>

                    <!--    Booking history record bot    -->
                    <div class="purchase-history__ticket__bot">
                      <div class="purchase-history__ticket__bot__time" DIR="ltr">
                        <div class="purchase-history__ticket__bot__pickup">
                          <div class="purchase-history__ticket__bot__pickup__icon">
                            <svg width="28" height="28" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z"
                                  stroke="#6C727A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M10.6667 1.33325V3.99992" stroke="#6C727A" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                              <path d="M5.33334 1.33325V3.99992" stroke="#6C727A" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                              <path d="M2 6.66675H14" stroke="#6C727A" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                            </svg>
                          </div>
                          <div class="purchase-history__ticket__bot__pickup__info">
                            <span>{{ $t('i_will_take') }}</span>
                            <span>{{ ensureDateTimeFormat(booking.pickup) }}</span>
                          </div>
                        </div>
                        <div class="purchase-history__ticket__bot__pickup">
                          <div class="purchase-history__ticket__bot__pickup__icon">
                            <svg width="28" height="28" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z"
                                  stroke="#6C727A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M10.6667 1.33325V3.99992" stroke="#6C727A" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                              <path d="M5.33334 1.33325V3.99992" stroke="#6C727A" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                              <path d="M2 6.66675H14" stroke="#6C727A" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                            </svg>
                          </div>
                          <div class="purchase-history__ticket__bot__pickup__info">
                            <span>{{ $t('i_will_return') }}</span>
                            <span>{{ ensureDateTimeFormat(booking.dropoff) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="purchase-history__ticket__bot__price">
                        <span dir="ltr">{{ booking.tax_total + ' ' + booking.total_currency }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="booking.service_type === ServiceTypes.SERVICE_TRANSPORTATION">
              <div class="purchase-history__ticket-wrapper col-12">
                <div class="purchase-history__ticket">
                  <div>
                    <!--    Booking history record top    -->
                    <div class="purchase-history__ticket__top">
                      <span class="purchase-history__ticket__top__id align-items-center" dir="ltr">
                        {{ 'Nr. ' + booking.id }} - {{ $t('passenger_transportation') }} ({{ booking.created_at.split('T')[0] }})
                      </span>
                      <div class="purchase-history__ticket__top__actions-wrapper">
                        <span class="purchase-history__ticket__top__actions"
                              @click="handleDownloadTicket(booking)"
                              v-if="booking.payment && booking.service_type === 'transportation'">
                          {{ $t('download_ticket') }}
                        </span>
<!--                        <span class="purchase-history__ticket__top__actions"-->
<!--                              @click="invoice()"-->
<!--                              v-if="booking.payment && booking.service_type === 'rent'"-->
<!--                        >-->
<!--                      {{ $t('invoice') }}-->
<!--                    </span>-->
                        <span class="purchase-history__ticket__top__actions"
                              @click="handlePayTheTransportationBooking(booking)"
                              v-if="!booking.payment && isBookingPickupDateLaterThanToday(booking)"
                        >
                            {{ $t('pay_order') }}
                        </span>
                      </div>
                    </div>
                    <!--    Booking history record mid    -->
                    <div class="purchase-history__ticket__mid">
                      <div class="purchase-history__ticket__mid-inner">
                        <span class=" purchase-history__ticket__mid-inner__title">{{ booking.pickup_addr }} - {{ booking.dest_addr }}</span>
                        <span class=" purchase-history__ticket__mid-inner__date">{{ booking.journey_date }}</span>
                      </div>
                    </div>
                    <!--    Booking history record bot    -->
                    <div class="purchase-history__ticket__bot">
                      <div class="purchase-history__ticket__bot__time" DIR="ltr">
                        <div class="purchase-history__ticket__bot__pickup">{{ ensureDateTimeFormat(booking.pickup) }}</div>
                      </div>
                      <div class="purchase-history__ticket__bot__price">
                    <span dir="ltr">{{ booking.tax_total/booking.travellers + ' ' + booking.total_currency + ' x ' + booking.travellers }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
      </div>
    </div>
    </div>
  </main>
</template>

<script lang="ts">
import './profilePurchaseHistoryPage.scss';

import {defineComponent} from "vue";

// @ts-ignore
import CustomerProfileNavComponent from "../../components/CustomerProfileNav/CustomerProfileNavComponent.vue";

import {routesConst} from "../../routes";
import axios from "axios";
import apiService from "../../services/apiService";
import type {IApiResponseBooking} from "@/interfaces/apiResponseInterfaces/IApiResponseBooking.interface";
import {ServiceTypes} from "../../interfaces/enums/ServiceTypes.enum";
import {useStore} from "vuex";
import NameOfHelper from "../../helpers/nameOfHelper";
import type {IApiResponseTransportationAddress} from "@/interfaces/apiResponseInterfaces/IApiResponseTransportationAddress.interface";
import type {ITicket} from "@/interfaces/ITicket.interface";
import type {IApiResponseTransportation, ICity} from "@/interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";
import type {ICustomRoute} from "@/store/states/ICustomRouteState.interface";

export default defineComponent({
  name: "ProfilePurchaseHistoryPage",
  components: {
    CustomerProfileNavComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    };
  },
  data() {
    return {
      ServiceTypes: ServiceTypes,
      bookings: <IApiResponseBooking[]>[],
    }
  },

  methods: {
    handleDownloadTicket(data) {
      this.$router.push({
        name: routesConst.TRANSPORTATION_TICKET,
        params: {
          bookingId: data.id,
          bookingData: JSON.stringify(data),
        },
        query: { id: data.id}
      });
    },

    handleDownloadInvoiceAndPreInvoice(bookingInvoiceUrl: string, bookingInvoiceFile: string): void {
      axios({
        url: bookingInvoiceUrl,
        method: 'GET',
        responseType: 'blob',
      }).then(res => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data]));
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', bookingInvoiceFile);
          document.body.appendChild(fileLink);

          fileLink.click();
      });
    },

    /**
     * NOTE: TODO Only order without driver covered
     * @param booking
     */
    handlePayTheBooking(booking: IApiResponseBooking): void {
      // in case if store is not empty...
      this.store.commit('order/CLEAR_STATE');
      this.store.commit('orderFalseDriver/CLEAR_STATE');
      this.store.commit('orderTrueDriver/CLEAR_STATE');

      // this.store.commit('orderTrueDriverRoute/CLEAR_STATE'); // TODO copy from order clear state
      // this.store.commit('orderTrueDriverDates/CLEAR_STATE'); // TODO copy from order clear state

      this.store.commit('orderTrueRoundTrip/CLEAR_STATE');
      this.store.commit('orderFalseRoundTrip/CLEAR_STATE');
      this.store.commit('vehicle/CLEAR_STATE');

      const nameOf = (c) => NameOfHelper.obj(c);
      const isWithDriver = !!booking.with_driver;

      let state = this.store.state.vehicle;
      this.store.commit( 'vehicle/SET_STATE_PROP_VALUE', [
          {prop: nameOf(() => state.selectedId), value: booking.vehicle.id},
          {prop: nameOf(() => state.selectedVehicle), value: booking.vehicle},
      ]);

      state = this.store.state.order;
      this.store.commit( 'order/SET_STATE_PROP_VALUE', [
          {prop: nameOf(() => state.withDriver), value: isWithDriver}, // TODO check if it's with or without
          {prop: nameOf(() => state.serviceType), value: booking.service_type}, // TODO Determine the service type earlier
      ]);

      switch (isWithDriver) {
          case true:
              const customRoutes: ICustomRoute[] = [];
              const arrivalTime = booking.pickup!.split(' ')[1].split(':')[0] + ':' + booking.pickup!.split(' ')[1].split(':')[1];
              const dropOffTime = booking.dropoff!.split(' ')[1].split(':')[0] + ':' + booking.dropoff!.split(' ')[1].split(':')[1];

              const routePickup = {
                  id: 0,
                  arrivalDate: booking.pickup!.split(' ')[0],
                  arrivalTime: arrivalTime,
                  routePoint: JSON.parse(booking.pickup_address_google_response!)
              }
              customRoutes.push(routePickup)

              const stopRoutes = booking.route!.map((el) => {
                  return {
                      id: el.order,
                      arrivalDate: null,
                      arrivalTime: el.arrival_time!.split(':')[0] + ':' + el.arrival_time!.split(':')[1],
                      routePoint: JSON.parse(el.point)
                  }
              });
              customRoutes.push(...stopRoutes);

              const routeDropOff = {
                  id: customRoutes.length,
                  arrivalDate: booking.dropoff!.split(' ')[0],
                  arrivalTime: dropOffTime,
                  routePoint: JSON.parse(booking.drop_off_address_google_response!)
              }
              customRoutes.push(routeDropOff);

              state = this.store.state.orderTrueDriverDates;
              const frequencyData = JSON.parse(booking.date_frequency!);

              this.store.commit('orderTrueDriverDates/SET_STATE_PROP_VALUE', [
                  {prop: nameOf(() => state.selectedPredefinedOption), value: frequencyData.selected_predefined_option},
                  {prop: nameOf(() => state.period), value: frequencyData.period},
                  {prop: nameOf(() => state.selectedPeriodType), value: frequencyData.selected_period_type},
                  {prop: nameOf(() => state.selectedDays), value: frequencyData.selected_days},
                  {prop: nameOf(() => state.firstSelectedDay), value: frequencyData.first_selected_day},
                  {prop: nameOf(() => state.selectedStartDate), value: frequencyData.selected_start_date},
                  {prop: nameOf(() => state.nthSelectedDay), value: frequencyData.nth_selected_day},
                  {prop: nameOf(() => state.selectedEndDate), value: frequencyData.selected_end_date},
                  {prop: nameOf(() => state.translatedSelectedDateText), value: frequencyData.translated_text},
              ]);

              state = this.store.state.orderTrueDriver;
              // filling store with new data from chosen booking
              this.store.commit( 'orderTrueDriver/SET_STATE_PROP_VALUE', [
                  {prop: nameOf(() => state.id), value: booking.id},
                  {prop: nameOf(() => state.passengerCount), value: booking.travellers},
                  {prop: nameOf(() => state.selectedTravelObjective), value: booking.travel_objective},
                  {prop: nameOf(() => state.totalDistance), value: booking.total_kms},
                  {prop: nameOf(() => state.totalDistance), value: booking.total_kms},
                  {prop: nameOf(() => state.price), value: booking.tax_total},
                  {prop: nameOf(() => state.totalDuration), value: {
                      hours: (booking.duration! - (booking.duration! % 60)) / 60,
                      minutes: booking.duration! % 60
                    }
                  },
                  {prop: nameOf(() => state.pickup), value: JSON.parse(booking.pickup_address_google_response!)},
                  {prop: nameOf(() => state.arrivalDate), value: new Date(Date.parse(booking.pickup!))},
                  {prop: nameOf(() => state.arrivalTime), value: arrivalTime},
                  {prop: nameOf(() => state.customRoutes), value: customRoutes}
              ]);

              break;

          case false:

              let pickupDate = <string|null>null;
              let pickupTime = <string|null>null;

              if (booking.pickup) {
                  const pickup = booking.pickup as string;
                  const pickupParts = pickup.split(' ');
                  const pickupTimeParts = pickupParts[1].split(':');

                  pickupDate = pickupParts[0] + 'T' + pickupParts[1] + '.000Z';
                  pickupTime = pickupTimeParts[0] + ':' + pickupTimeParts[1];
              }

              if (! pickupDate || ! pickupTime) {
                  alert('Something went wrong. Please try again later. If the problem persists please contact us!');
                  throw new Error('Order can\'t be without dates!');
              }

              let endDate = <string|null>null;
              let endTime = <string|null>null;

              if (booking.dropoff) {
                  const end = booking.dropoff as string;
                  const endParts = end.split(' ');
                  const endTimeParts = endParts[1].split(':');

                  endDate = endParts[0] + 'T' + endParts[1] + '.000Z';
                  endTime = endTimeParts[0] + ':' + endTimeParts[1];
              }

              state = this.store.state.orderFalseDriver;
              // filling store with new data from chosen booking
              this.store.commit( 'orderFalseDriver/SET_STATE_PROP_VALUE', [
                  {prop: nameOf(() => state.id), value: booking.id},
                  {prop: nameOf(() => state.isRentFormValid), value: true},
                  {prop: nameOf(() => state.passengerCount), value: booking.travellers},

                  {prop: nameOf(() => state.pickupTime), value: pickupTime},
                  {prop: nameOf(() => state.pickupDate), value: pickupDate},

                  {prop: nameOf(() => state.endTime), value: endTime},
                  {prop: nameOf(() => state.endDate), value: endDate},

                  {prop: nameOf(() => state.destination), value: JSON.parse(booking.pickup_address_google_response!)},
                  {prop: nameOf(() => state.formatted_address), value: booking.pickup_addr},
              ]);

              break;
      }

      // INITIALIZE
      this.store.commit('order/INITIALIZE_ORDER_STATE');
      this.store.commit('orderFalseDriver/INITIALIZE_FALSE_DRIVER_ORDER_STATE');
      this.store.commit('orderTrueDriver/INITIALIZE_TRUE_DRIVER_ORDER_STATE');
      this.store.commit('orderTrueRoundTrip/INITIALIZE_TRUE_ROUND_TRIP_STATE');
      this.store.commit('orderFalseRoundTrip/INITIALIZE_FALSE_ROUND_TRIP_STATE');
      this.store.commit('vehicle/INITIALIZE');

      setTimeout(() => {
        this.$router.push(routesConst.ORDER);
      });
    },

    handlePayTheTransportationBooking(booking: IApiResponseBooking): void {
      // in case if store is not empty...
      this.store.commit('order/CLEAR_STATE');
      this.store.commit('orderFalseDriver/CLEAR_STATE');
      this.store.commit('orderTrueDriver/CLEAR_STATE');

      // this.store.commit('orderTrueDriverRoute/CLEAR_STATE'); // TODO copy from order clear state
      // this.store.commit('orderTrueDriverDates/CLEAR_STATE'); // TODO copy from order clear state

      this.store.commit('orderTrueRoundTrip/CLEAR_STATE');
      this.store.commit('orderFalseRoundTrip/CLEAR_STATE');
      this.store.commit('vehicle/CLEAR_STATE');

      const nameOf = (c) => NameOfHelper.obj(c);
      const isRoundTrip = !!booking.round_trip;
      const action = isRoundTrip ? 'orderTrueRoundTrip/SET_STATE_PROP_VALUE' : 'orderFalseRoundTrip/SET_STATE_PROP_VALUE';

      let state = this.store.state.order;
      this.store.commit( 'order/SET_STATE_PROP_VALUE', [
          {prop: nameOf(() => state.roundTrip), value: isRoundTrip},
          {prop: nameOf(() => state.withDriver), value: false},
          {prop: nameOf(() => state.serviceType), value: booking.service_type},
      ]);

      // NOTE: STATE CHANGE FOR TRANSPORTATION STATE VALUES SET
      state = isRoundTrip ? this.store.state.orderTrueRoundTrip : this.store.state.orderFalseRoundTrip;

      let ids: {forward: number|null, back: number|null} | null = { forward: booking.id, back: booking.booking_related_id };

      if (isRoundTrip && booking.id! > booking.booking_related_id!) {
          ids.forward = booking.booking_related_id;
          ids.back = booking.id;
      }

      const forwardBooking = this.bookings.find(el => el.id === ids!.forward)!;
      const pickUpRoundTrip = this.handleTransportationAddressBuild(forwardBooking, 'pickup_address');
      const dropOffRoundTrip = this.handleTransportationAddressBuild(forwardBooking, 'drop_off_address');

      this.store.commit(action, [
          {prop: nameOf(() => state.ids), value: ids},
          {prop: nameOf(() => state.pickUp), value: pickUpRoundTrip},
          {prop: nameOf(() => state.dropOff), value: dropOffRoundTrip},
          {prop: nameOf(() => state.tripPassengers), value: forwardBooking.travellers},

      ]);

      switch (isRoundTrip) {
          case true:
              const backBooking = this.bookings.find(el => el.id === ids!.back)!;
              const forwardTicket: ITicket = this.handleTicketDataObjectBuild(forwardBooking);
              const backTicket: ITicket = this.handleTicketDataObjectBuild(backBooking);

              this.store.commit('orderTrueRoundTrip/SET_STATE_PROP_VALUE', [
                  {prop: nameOf(() => state.tripDepartureDate), value: new Date(Date.parse(forwardBooking!.pickup!))},
                  {prop: nameOf(() => state.tripArrivalDate), value: new Date(Date.parse(backBooking!.pickup!))},

                  {prop: nameOf(() => state.forwardTicket), value: forwardTicket},
                  {prop: nameOf(() => state.backTicket), value: backTicket},
              ]);

              break;

          case false:
              const transportationData = this.handleTransportationDataObjectBuild(forwardBooking);

              this.store.commit('orderFalseRoundTrip/SET_STATE_PROP_VALUE', [
                  {prop: nameOf(() => state.transportationId), value: forwardBooking.transportation_id},
                  {prop: nameOf(() => state.tripDepartureDate), value: new Date(Date.parse(forwardBooking.pickup!))},

                  {prop: nameOf(() => state.transportations), value: [transportationData]},
              ]);

              break;
      }

      // INITIALIZE
      this.store.commit('order/INITIALIZE_ORDER_STATE');
      this.store.commit('orderFalseDriver/INITIALIZE_FALSE_DRIVER_ORDER_STATE');
      this.store.commit('orderTrueDriver/INITIALIZE_TRUE_DRIVER_ORDER_STATE');
      this.store.commit('orderTrueRoundTrip/INITIALIZE_TRUE_ROUND_TRIP_STATE');
      this.store.commit('orderFalseRoundTrip/INITIALIZE_FALSE_ROUND_TRIP_STATE');
      this.store.commit('vehicle/INITIALIZE');

      setTimeout(() => {
          this.$router.push(routesConst.ORDER);
      });
    },

    handleTicketDataObjectBuild(data: IApiResponseBooking): ITicket {

        const transportation = data.transportation!;

        return {
            transportationId: data!.transportation_id,
            isSelected: true,
            data: {
                id: transportation.id,
                title: transportation.title,
                pickup_time: transportation.pickup_time,
                drop_off_time: transportation.drop_off_time,
                pickup_city: this.handlePickupDropOffPlaceBuild(transportation.pickup_address),
                dropoff_city: this.handlePickupDropOffPlaceBuild(transportation.drop_off_address),
                transportation_stop: transportation.transportation_stop,
                map_response: transportation.map_response,
                map_response_time: transportation.map_response_time,
                price: transportation.price,
                totals: {
                    tax_total: data.tax_total
                },
                travel_time: transportation.travel_time
            },

            tripDate: new Date(Date.parse(data!.pickup!)),
            pickUp: this.handleTransportationAddressBuild(data, 'pickup_address'),
            dropOff: this.handleTransportationAddressBuild(data, 'drop_off_address'),
        }
    },

    handleTransportationDataObjectBuild(data: IApiResponseBooking): IApiResponseTransportation {

        let transportation = data.transportation!;

        return {
            id: transportation.id,
            title: transportation.title,
            pickup_time: transportation.pickup_time,
            drop_off_time: transportation.drop_off_time,
            pickup_city: this.handlePickupDropOffPlaceBuild(transportation.pickup_address),
            dropoff_city: this.handlePickupDropOffPlaceBuild(transportation.drop_off_address),
            transportation_stop: transportation.transportation_stop,
            map_response: transportation.map_response,
            map_response_time: transportation.map_response_time,
            price: transportation.price,
            totals: {
                tax_total: data.tax_total! / data.travellers!
            },
            travel_time: transportation.travel_time
        }
    },

    handleTransportationAddressBuild(data: IApiResponseBooking, addressKeyString): IApiResponseTransportationAddress {
        const transportationAddress = data.transportation![addressKeyString];

        return {
            address: transportationAddress.address,
            address_to_show: transportationAddress.address_to_show,
            city: transportationAddress.city,
            id: transportationAddress.id,
        }
    },

    handlePickupDropOffPlaceBuild(data: ICity): ICity {
      return {
          address: data.address,
          address_to_show: data.address_to_show,
          city: data.city,
          id: data.id,
          lat: data.lat,
          lng: data.lng
      }
    },

    /**
     * Example: '2022-01-01 01:00:00' -> '2022-01-01 01:00
     * @param {string} str
     */
    ensureDateTimeFormat(str: string): string {
      const pickupParts = str.split(' ');
      const pickupTimeParts = pickupParts[1].split(':');

      return pickupParts[0] + ' ' + pickupTimeParts[0] + ':' + pickupTimeParts[1];
    },
    /**
     * @param {IApiResponseBooking} booking
     */
    isBookingPickupDateLaterThanToday(booking: IApiResponseBooking): boolean {
      return new Date(booking.pickup as string).getTime() > new Date().getTime();
    },
    getBookings() {
      axios.get(apiService.customerGetBookings())
          .then(response => {
            this.bookings = <IApiResponseBooking[]>response.data.data;
          })
          .catch(err => {
            console.error(err);
          })
    }
  },

  mounted() {
    this.getBookings();
  },
})
</script>

<style scoped>

</style>